import {
  Seo,
  Hero,
  Carousel,
} from 'ui'
import {
  useGetCarousels,
  useGetCarouselVideo,
} from 'api/content'
import { CarouselsWrapper } from './styles'
import { GROUP_ID } from 'utils/constants'
import { useTranslation } from 'react-i18next'


const Community = () => {

  const { t } = useTranslation()

  const { data: carousels } = useGetCarousels(GROUP_ID.community)

  return (
    <>
      <Seo
        title={t('seoCommunityTitle')}
        description={t('seoCommunityDescription')}
      />

      <Hero />

      <CarouselsWrapper>
        {/*
          *   CAROUSELS
         **/}
         { carousels.map( carousel => {
          if (!carousel.uuid) return null
          return (
            <Carousel
              key={carousel.uuid}
              uuid={carousel.uuid}
              title={carousel.title}
              fetchFn={useGetCarouselVideo}
            />
          )
        })}
      </CarouselsWrapper>
    </>
  )
}

export default Community
